<template>
  <div class="alt-engraving-design-row">
    <div class="alt-engraving__item" :id="`alt-engraving__item-${keyEngraving}`">
      <div
        class="alt-engraving__thumbnail"
        @click="show_engraving__modal(thubmnailImgSrc.thumbnail, keyEngraving)"
      >
        <img
          :src="`${baseUrl}api/wp-content/uploads/${thubmnailImgSrc.thumbnail_lazy || thubmnailImgSrc.thumbnail}`"
          :data_original_src="`${baseUrl}api/wp-content/uploads/${thubmnailImgSrc.thumbnail}`"
          class="alt-engraving__design-thubmnail"
          :data_term="thubmnailImgSrc.term_id"
          :data_term_name="thubmnailImgSrc.term_name"
          :alt="thubmnailImgSrc.alt ?? ''"
        />
        <div class="alt-engraving__zoom-hover">
          <img src="/single-product/zoom-icon.webp" alt="zoom-icon" />
        </div>
      </div>
      
      <div class="alt-engraving__details">
        <div class="alt-engraving__product-info">
          <h4 class="alt-engraving__product-title" v-html="engravingproducttitle"></h4>
        </div>
        <div class="alt-engraving__engraving-design">
          <div class="alt-engraving__select-design" ref="designBox" @click="toggleDesignSelector">
            <div class="alt-engraving__design-selector">
              <div class="alt-engraving__design-selected">
                <span class="alt-engraving__design-label">Design</span>
                <span
                  class="alt-engraving__selected" v-html="engravingselectedtitle"
                ></span>
              </div>
              <ul
                class="alt-engraving__design-items"
                :class="isActive_design ? 'active' : ''"
                :style="activeStyleDesign"
                ref="designItems"
              >
                <template v-for="(item, index) in engravingDesigns" :key="index">
                  <li
                    :class="{ 'active-design': selectedEngraving === item.term_id }"
                    @click="selectEngravingDesign(item.term_name, item.term_id)"
                    :data-stock="item.stock"
                    :data-label="item.term_name"
                  >
                    <input
                      type="radio"
                      :name="`engraving_item[${keyEngraving}][design]`"
                      :id="`alt-engraving-desgin-item-${keyEngraving}-${item.term_id}`"
                      class="alt-engraving-desgin-img input-hidden"
                      :value="item.term_id"
                      :checked="selectedEngraving === item.term_id"
                    />
                    <span v-html="item.term_name"></span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div v-if="engravingSettings.isEngravingOptionEnable && !hide_engraving" ref="designBox2" class="alt-engraving__select-engraving" @click="toggleEngravingSelector">
            <div class="alt-engraving__engraving-selector">
              <div class="alt-engraving__engraving-selected">
                <span class="alt-engraving__engraving-label">Engraving</span>
                <span
                  :class="`alt-engraving__selected alt-engraving__selected-${keyEngraving}`"
                  v-html="engraving__selected"
                  ></span
                >
              </div>
              <ul
                class="alt-engraving__engraving-items"
                 :class="isActive_engraving ? 'active' : ''"
                  :style="activeStyleEngraving"
                ref="engravingItems"
              >
                <li
                  @click="enableEngraving($event, keyEngraving,'')"
                  data-price="0"
                  data-value="0"
                  :data-engravingPrice="engravingSettings.engravingFee"
                >
                  No
                </li>
                <li
                  @click="enableEngraving($event, keyEngraving,engravingSettings.engravingProductFee)"
                  :data-price="engravingSettings.engravingFee"
                  :data-pid="engravingSettings.engravingProductFee"
                  :data-value="engravingSettings.engravingProductFee"
                >
                  <!-- Yes (+ ${{ engravingSettings.engravingFee }}) -->
                  Yes (+ <span v-html="displayCustomPrice(engravingSettings.engravingFee)"></span>)
                </li>
                <input
                  :data-price="engravingSettings.engravingFee"
                  :id="`alt-engraving-desgin-checkbox-${index}`"
                  class="alt-engraving-desgin-mask woocommerce-form__input woocommerce-form__input-checkbox input-hidden"
                  :dat-index="index"
                  type="checkbox"
                  :name="`engraving_item[${index}][add]`"
                  value="1"
                />
              </ul>
            </div>
          </div>
        </div>
        <div
          class="alt-engraving__final-result" v-if="!hide_engraving"
          :style="isActive_finalresult ? `display : block` : `display : none`"
        >
          <span class="alt-engraving__note">*{{ engravingSettings.engravingNote }}</span>
          <div
            class="alt-engraving__result"
            :id="`alt-engraving__result-${keyEngraving}`"
            @click="showpopup_engraving_design_modal()"
          >
            <span>{{ parentValue[keyEngraving] }}</span>
            <img src="/single-product/pencil-icon.png" alt="pencil-icon" />
          </div>
        </div>
      </div>
     
      <input
        type="hidden"
        :name="`engraving_data[${index}]`"
        :id="`engraving_data_${index}`"
        class="alt-engraving__engraving-data"
        data-item="1"
        data-design=""
        data-font=""
        data-text=""
      />
      
      <input
        v-model="engravingName"
        type="hidden"
        name="alt-engraving-desgin-name"
        :id="`alt-engraving-desgin-name-${index}`"
        class="alt-engraving-desgin-name"
      />
      <input
        v-model="engravingFont"
        type="hidden"
        name="alt-engraving-desgin-font"
        :id="`alt-engraving-desgin-font-${index}`"
        class="alt-engraving-desgin-font"
      />
      <input
        type="hidden"
        name="alt-engraving-desgin-product_fee"
        :id="`alt-engraving-desgin-product_fee-${index}`"
        class="alt-engraving-desgin-product_fee"
        value=""
      />
      <input type="hidden" :id="`alt-engraving-has-selection-${index}`"
        class="alt-engraving__has-manual-selection" :value="hasManualSelection || isEngravingEnabled ? 'yes' : 'no'" />
    </div>
    <div :id="`alt-engraving__modal-${keyEngraving}`" class="alt-engraving__modal">
      <span
        class="alt-engraving__modal-close"
        @click="close_engraving__modal(keyEngraving)"
        >x</span
      >
      <div class="alt-engraving__modal-image">
        <img :src="`${baseUrl}api/wp-content/uploads/${modalImgSrc}`" />
      </div>
      <div class="alt-engraving__modal-captions" v-html="modalcaptions"></div>
    </div>
    <EngravingModal
      v-if="showModal"
      @close="hidepopup_engraving_design_modal"
      :keyModal="keyEngraving"
      :value="parentValue[keyEngraving]"
      :engravingSettings="engravingSettings"
      @update:value="(newValue) => updateValue(keyEngraving, newValue)"
      @sendEngravingData="handleEngravingData"
    />
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/components/product/_engraving.scss";
</style>

<script setup lang="ts">
import { eventNames } from "process";
import { displayCustomPrice, displayPrice } from "~/utils/displayPrice"
import EngravingModal from "./EngravingModal.vue";
const props = defineProps({
  key: {
    type: Number,
    required: true,
  },
  isChange: {
    type: Number,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  priceInfo: {
    type: Object,
    required: true,
  },
  keyEngraving: {
    type: Number,
    required: true,
  },
  isNoOption: {
    type: Boolean,
    required: false,
  },
  index: {
    type: Number,
    required: false,
  },
  totalItems: {
    type: Number,
    required: false,
    default: 1
  }
});
const index = computed(() => props.index);
const parentIndex = computed(() => props.index);
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const engravingData = computed(() => props.data);
const engravingProduct = computed(() => engravingData.value.engravingDataProduct);
const engravingDesigns = computed(() => engravingProduct.value.designs);
const engravingSettings = computed(() => engravingProduct.value.engravingSettings);
// const engravingDesignsActive = computed(() => engravingDesigns.value[0]);
// const thubmnailImgSrc = ref();
// thubmnailImgSrc.value = engravingDesignsActive.value;
// const engravingselectedtitle = ref(engravingDesignsActive.value.term_name);
// const engravingproducttitle = ref("Design: " + engravingselectedtitle.value);

// Check if fixed design option should be used
const isFixedDesignOnly = computed(() => {
  return props.totalItems >= 2 && (engravingSettings.value?.allow_fixed_design_option_only === true || engravingSettings.value?.allowFixedDesignOptionOnly === true);
});

// Get the design assigned to this item based on its index
const getAssignedDesignForItem = computed(() => {
  if (!isFixedDesignOnly.value) return null;
  
  // Get designs sorted by their keys (numeric order: 0, 1, 2, ...)
  const designsObj = engravingDesigns.value || {};
  const sortedKeys = Object.keys(designsObj).sort((a, b) => {
    const numA = parseInt(a, 10);
    const numB = parseInt(b, 10);
    return numA - numB;
  });
  
  if (sortedKeys.length === 0) return null;
  
  // Assign design to item based on keyEngraving index
  const designIndex = Math.min(props.keyEngraving, sortedKeys.length - 1);
  return designsObj[sortedKeys[designIndex]] || null;
});

// Check if this item is out of stock when fixed design is enabled
const isItemOutOfStock = computed(() => {
  if (!isFixedDesignOnly.value) return false;
  
  // Get number of designs sent from backend
  const designsObj = engravingDesigns.value || {};
  const designsCount = Object.keys(designsObj).length;
  
  // Item is out of stock if keyEngraving >= number of designs available
  // e.g., if only 1 design sent (for buy2), item 0 shows it, item 1+ are out of stock
  return props.keyEngraving >= designsCount;
});

// Get first design from object (keys are "0", "1", etc)
const engravingDesignsActive = computed(() => {
  const designs = engravingDesigns.value || {};
  const firstDesign = Object.values(designs)[0];
  return firstDesign || null;
});

const thubmnailImgSrc = ref<any>(null);
const engravingselectedtitle = ref<string>("");
const engravingproducttitle = ref<string>("Design");

const isActive_design = ref(false);
const isActive_engraving = ref(false);
const isActive_finalresult = ref(false);
const engraving__selected = ref("No");
const parentValue = ref([
  "Write a Name or Blessing",
  "Write a Name or Blessing",
  "Write a Name or Blessing",
  "Write a Name or Blessing",
]);
interface IEngravingDesign {
  stock: number;
  thumbnail: string;
  lazy: string;
  term_name: string;
  term_id: string;
}
  const getFirstAvailableDesign = (keyEngraving: number) => {
    for (const design of Object.values(engravingDesigns.value)) {
      const availableInUl = canShowDesign(design, keyEngraving);
      if (availableInUl) {
        return design;
      }
    }
    return null;
  };
  const hasManualSelection = ref(false);
  const updateTitlesForUl = (keyEngraving: number) => {
    if (hasManualSelection.value) return;
    // If fixed design is enabled and item is out of stock, don't update titles
    if (isFixedDesignOnly.value && isItemOutOfStock.value) {
      return;
    }
    
    // If fixed design is enabled, use the assigned design for this item
    if (isFixedDesignOnly.value) {
      const assignedDesign = getAssignedDesignForItem.value;
      if (assignedDesign) {
        engravingselectedtitle.value = assignedDesign.term_name;
        engravingproducttitle.value = `Design: ${assignedDesign.term_name}`;
        thubmnailImgSrc.value = assignedDesign;
      }
      return;
    }
  };

const canShowDesign = (design:IEngravingDesign, keyEngraving: number) => {
  return keyEngraving < design.stock;
};
const updateValue = (keyEngraving: number, newValue: any) => {
  parentValue.value[keyEngraving] = newValue;
};
const designBox = ref<HTMLElement | null>(null)
const designBox2 = ref<HTMLElement | null>(null)
const toggleDesignSelector = () => {
  //console.log('toggleDesignSelector');
  if( isActive_engraving.value ) {
    isActive_engraving.value = false;
  }
  isActive_design.value = !isActive_design.value;
};
// Initialize selectedEngraving as null and let watch set it
const selectedEngraving = ref<string | null>(null);

const handleClickOutside = (event) => {
  if (designBox.value && !designBox.value.contains(event.target)) {
    isActive_design.value = false;
  }
  if (designBox2.value && !designBox2.value.contains(event.target)) {
    isActive_engraving.value = false;
  }
}

// For fixed design option, track the selected design ID
const fixedDesignId = computed(() => {
  if (!isFixedDesignOnly.value) return null;
  const assignedDesign = getAssignedDesignForItem.value;
  return assignedDesign?.term_id || null;
});

const dataStocks = computed(() => {
  const designs = engravingDesigns.value || {};
  return (Object.values(designs) as IEngravingDesign[]).map((engraving) => engraving.stock);
});

const selectEngravingDesign = (designText: string, designId: string) => {
    selectedEngraving.value = designId;
    engravingproducttitle.value = `Design: ${designText}`;
    engravingselectedtitle.value = designText;
    const selectedDesign = Object.values(engravingDesigns.value).find(
        (design: any) => design.term_id === designId
    );
    if (selectedDesign) {
        thubmnailImgSrc.value = selectedDesign;
    }
    // Only set hasManualSelection true for Buy1 (not fixed design mode)
    if (!isFixedDesignOnly.value) {
      hasManualSelection.value = true;
    }
};

const toggleEngravingSelector = () => {
  //console.log('toggleEngravingSelector', isActive_design.value);
  if( isActive_design.value ) {
    isActive_design.value = false;
  }

  isActive_engraving.value = !isActive_engraving.value;
};
const priceAdded = ref(false);
watch(
  () => props.isNoOption,
  () => {
    hasManualSelection.value = false;
    isActive_finalresult.value = false;
    engraving__selected.value = "No";
    priceAdded.value = false;
  }
);

watch(
  () => props.totalItems,
  () => {
    hasManualSelection.value = false;
    selectedEngraving.value = null;  // Reset selectedEngraving so watch(engravingDesigns) will re-trigger
  }
);
// Watch designs to initialize title, thumbnail, and selectedEngraving
watch(
  () => engravingDesigns.value,
  (designs) => {
    if (!designs || Object.keys(designs).length === 0) return;
    
    const firstDesign = Object.values(designs as any)[0] as any;
    if (!firstDesign) return;
    
    // Update title and thumbnail
    thubmnailImgSrc.value = firstDesign;
    engravingselectedtitle.value = firstDesign.term_name;
    engravingproducttitle.value = `Design: ${firstDesign.term_name}`;
    
    // Auto-set selectedEngraving if not already set (for both Buy1 and Buy2+ fallback)
    // autoSelectFixedDesign will override this for Buy2+ items
    if (!selectedEngraving.value) {
      selectedEngraving.value = firstDesign.term_id;
    }
  },
  { immediate: true, deep: true }
);

// Watch selectedEngraving - if it's reset to null, set it back to first design
watch(
  () => selectedEngraving.value,
  (newVal) => {
    if (newVal === null && !isFixedDesignOnly.value) {
      const designs = engravingDesigns.value || {};
      const firstDesign = Object.values(designs)[0] as any;
      if (firstDesign) {
        selectedEngraving.value = firstDesign.term_id;
      }
    }
  }
);

watchEffect(() => {
  if (!hasManualSelection.value) {
    updateTitlesForUl(props.keyEngraving);
    if (isFixedDesignOnly.value) {
      // For fixed design option (Buy2+), auto-select design for each item
      autoSelectFixedDesign();
    }
  }
});

const autoSelectFixedDesign = () => {
  if (!isFixedDesignOnly.value) return;
  
  // Don't select design if item is out of stock
  if (isItemOutOfStock.value) return;

  nextTick(() => {
    // Get the assigned design for this item
    const assignedDesign = getAssignedDesignForItem.value;
    
    if (assignedDesign) {
      // For fixed mode, directly set selectedEngraving without marking as manual
      selectedEngraving.value = assignedDesign.term_id;
      engravingselectedtitle.value = assignedDesign.term_name;
      engravingproducttitle.value = `Design: ${assignedDesign.term_name}`;
      thubmnailImgSrc.value = assignedDesign;
    }
  });
};



const autoActive = computed(() => engravingSettings.value?.isEngravingAutoActive ?? false);
const emit = defineEmits(["handleShowEngraving", "handleClose", "update-price"]);
const isEngravingEnabled = ref(false);
const initialPriceInfo = props.priceInfo;
const selectedEngravings = ref<Record<number, boolean>>({});
const handleChangePrice = () => {
  let engravingTotalPrice = 0;
  const _selectedEngraving: NodeListOf<HTMLInputElement> = document.querySelectorAll(".alt-engraving-desgin-mask");
  if (_selectedEngraving.length > 0){
    _selectedEngraving.forEach((input, index) => {
      if (input.checked){
        let price = Number(input.dataset.price);
        engravingTotalPrice += price;
      }
    })
  }
  const initialSalePrice = ref(initialPriceInfo.sale_price);
  const initialRegularPrice = ref(initialPriceInfo.regular_price);
  const initialPrice = ref(initialPriceInfo.price);

  const currentSalePrice: Number | null = initialSalePrice.value
    ? parseFloat(initialSalePrice.value) + engravingTotalPrice
    : null;
  const currentRegularPrice = parseFloat(initialRegularPrice.value) + engravingTotalPrice;
  const currentPrice = parseFloat(initialPrice.value) + engravingTotalPrice;
  const newPriceInfo = {
    sale_price: currentSalePrice?.toString(),
    regular_price: currentRegularPrice.toString(),
    price: currentPrice.toString(),
  };

  emit("update-price", newPriceInfo);
}
const enableEngraving = (event: Event, keyEngraving: number,pid:string) => {
  const currentSalePrice = ref(props.priceInfo.sale_price);
  const currentRegularPrice = ref(props.priceInfo.regular_price);
  const currentPrice = ref(props.priceInfo.price);
  const initialSalePrice = ref(props.priceInfo.sale_price);
  const initialRegularPrice = ref(props.priceInfo.regular_price);
  const initialPrice = ref(props.priceInfo.price);
  if (event.target instanceof HTMLElement) {
    engraving__selected.value = event.target.innerHTML;
    const price = Number(event.target.dataset.price);
    const addEngraving = Number(event.target.dataset.value);
    if (addEngraving !== 0) {
      isActive_finalresult.value = true;
      isEngravingEnabled.value = true;
      hasManualSelection.value = true; // Mark as manually selected
      selectedEngravings.value[keyEngraving] = true;

      // Only add price once
      if (!priceAdded.value) {
        currentSalePrice.value = currentSalePrice.value
          ? parseFloat(currentSalePrice.value) + price
          : null;
        currentRegularPrice.value = parseFloat(currentRegularPrice.value) + price;
        currentPrice.value = parseFloat(currentPrice.value) + price;
        const newPriceInfo = {
          sale_price: currentSalePrice.value,
          regular_price: currentRegularPrice.value,
          price: currentPrice.value,
        };
        priceAdded.value = true;
      }
      const engravingFeeId =
        (event.target
          .closest(".alt-engraving-design-row")
          ?.querySelector(".alt-engraving-desgin-product_fee") as HTMLInputElement) ||
        null;
      if (engravingFeeId) {
        //engravingFeeId.value = event.target.getAttribute("data-pid")!;
        engravingFeeId.value = pid;
      }
    } else {
      // const engravingFeePrice = Number( event.target.getAttribute("data-engravingPrice"));
      // Click "No" - hide final result and disable engraving
      isActive_finalresult.value = false;
      isEngravingEnabled.value = false;
      hasManualSelection.value = false; // Clear manual selection
      selectedEngravings.value[keyEngraving] = false
      if (priceAdded.value === true){
        const engravingFeePrice = Number(event.target.getAttribute("data-engravingPrice"));
        currentSalePrice.value = initialSalePrice.value ? Number(initialSalePrice.value) - engravingFeePrice : '';
        currentRegularPrice.value = Number(initialRegularPrice.value) - engravingFeePrice;
        currentPrice.value = Number(initialPrice.value) - engravingFeePrice;
        const newPriceInfo = {
          sale_price: currentSalePrice.value,
          regular_price: currentRegularPrice.value,
          price: currentPrice.value,
        };
        // emit("update-price", newPriceInfo);
        priceAdded.value = false;
      }
      // priceAdded.value = false;
      // isEngravingEnabled.value = false;
      // selectedEngravings.value[keyEngraving] = false
      const engravingFeeId =
        (event.target
          .closest(".alt-engraving-design-row")
          ?.querySelector(".alt-engraving-desgin-product_fee") as HTMLInputElement) ||
        null;
      if (engravingFeeId) {
        engravingFeeId.value = "";
      }
    }
    // Update checkbox state
    if (addEngraving !== 0){
      const input: HTMLInputElement = event.target.closest(".alt-engraving__engraving-items")?.querySelector("input.alt-engraving-desgin-mask");
      if (input) {
        input.checked = true;
      }
    }else{
      const input: HTMLInputElement = event.target.closest(".alt-engraving__engraving-items")?.querySelector("input.alt-engraving-desgin-mask");
      if (input) {
        input.checked = false;
      }
    }
  }
  handleChangePrice();
};

const designItems = ref(null);
const engravingItems = ref(null);
const activeStyleDesign = computed(() => {
  if (isActive_design.value && designItems.value) {
    const height = designItems.value.scrollHeight + 16 + 'px';
    return {
      height: height,
      opacity: 1,
      padding: '8px 0',
      marginTop: '5px'
    };
  }
  return {
    height: '0',
    opacity: 0,
     padding: '0',
     marginTop: '0'
  };
});
const activeStyleEngraving = computed(() => {
  if (isActive_engraving.value && engravingItems.value) {
    const height = engravingItems.value.scrollHeight + 16 + 'px';
    return {
      height: height,
      opacity: 1,
       padding: '8px 0',
       marginTop: '5px'
    };
  }

  return {
    height: '0',
    opacity: 0,
    padding: '0',
    marginTop: '0'
  };
});
const modalImgSrc = ref("");
const modalcaptions = ref("");
const show_engraving__modal = (src: string, keyEngraving: number) => {
  const showengravingModal = document.querySelector(
    `#alt-engraving__modal-${keyEngraving}`
  );
  if (showengravingModal) {
    modalImgSrc.value = src;
    modalcaptions.value = engravingselectedtitle.value;
    showengravingModal.classList.add("active");
  }
};

const close_engraving__modal = (keyEngraving: number) => {
  const showengravingModal = document.querySelector(
    `#alt-engraving__modal-${keyEngraving}`
  );
  if (showengravingModal) {
    // Corrected the condition
    showengravingModal.classList.remove("active"); // Close the modal
  }
};

//end modal zoom
const showModal = ref(false);

const hidepopup_engraving_design_modal = () => {
  showModal.value = false;
};

const showpopup_engraving_design_modal = () => {
  showModal.value = true;
};
const engravingName = ref("");
const engravingFont = ref("");
const handleEngravingData = (data: { text: string; font: string }) => {
  engravingName.value = data.text;
  engravingFont.value = data.font;
};

const handleTriggerFirstOption = () => {
  //console.log('handleTriggerFirstOption', props.isChange);

  if( props.isChange > 0 ) {
    return;
  }
  //console.log('RUN===handleTriggerFirstOption', isActive_design.value);
  const engravingRows = document.querySelectorAll('.alt-engraving-design-row');
  const isEngraving = document.querySelector('.alt-engraving__engraving-selected');
  if (engravingRows.length > 0 && isEngraving) {
    engravingRows.forEach((element, index) => {
      const engravingList = element.querySelector('.alt-engraving__design-items');
      if (!engravingList) return;

      const firstItem = engravingList.querySelector('li:first-child input[name^="engraving_item"]');
      if (firstItem) {
        firstItem.click();

        setTimeout(function(){
          engravingList.removeAttribute('style');
          engravingList.classList.remove('active');
        }, 10);

        setTimeout(function(){
          //console.log('isActive_design.value', isActive_design.value);
          isActive_design.value = false;
        }, 1000);
      }
    });
  }
}

const autoSelectEngraving = () => {
  if (!autoActive.value) return;

  nextTick(() => {
    // Find all engraving items containers for the current engraving component
    const engravingItemsContainers = document.querySelectorAll(`#alt-engraving__item-${props.keyEngraving} .alt-engraving__engraving-items`);
    
    engravingItemsContainers.forEach(container => {
      const yesOption = container.querySelector('li:nth-child(2)');
      
      if (yesOption) {
        // Create a mock event object
        const mockEvent = {
          target: yesOption as HTMLElement,
          currentTarget: yesOption as HTMLElement,
          preventDefault: () => {},
          stopPropagation: () => {},
        };
        
        // Get the engraving product fee from data attributes
        const engravingProductFee = yesOption.getAttribute('data-pid') || engravingSettings.value.engravingProductFee;
        
        // Call enableEngraving with the mock event
        enableEngraving(mockEvent, props.keyEngraving, engravingProductFee);
      }
    });
  });
};

// Get hide_engraving value from the selected design
const hide_engraving = computed(() => {
  if (selectedEngraving.value === null) return false;
  
  const designs = engravingDesigns.value || {};
  const selectedDesign = Object.values(designs).find(
    (design: any) => design.term_id === selectedEngraving.value
  );
  
  return selectedDesign?.hide_engraving || false;
});

watch(
  () => props.isChange,
  (newValue, oldValue) => {
    // handleTriggerFirstOption();
    if (isFixedDesignOnly.value) {
      autoSelectFixedDesign();
    }
    autoSelectEngraving();
  },
  { immediate: true }
);


onMounted(() => {
  altLazyIO();
  document.addEventListener("click", handleClickOutside)
})
onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside)
})
</script>
